export const services = [
  {
    indx: '01',
    title: "UI/UX Designing",
    description: "HNH Soft Tech Solutions understands the needs of enhancing growth your business ideas by delivering the most amazing web designing services."

  },
  {
    indx: '02',
    title: "Website Development",
    description: "Web Improvement Is The Work Engaged With Building Up A Site For The Internet (World Wide Web) Or An Intranet (A Private Network)."

  },
  {
    indx: '03',
    title: "App Design & Development",
    description: "For clients that want custom mobile app development solution, HNH Soft Tech Solutions offers unique, compatible solutions."

  },
  {
    indx: '04',
    title: "Machine Learning",
    description: "Machine learning (ML) is a field of inquiry devoted to understanding and building methods that learn from data and improve performance."

  },
  {
    indx: '05',
    title: "Digital Marketing",
    description: "Leverage the skills of our company’s digital marketing services capable of delivering outstanding marketing strategies."

  },
];

export const service = [
  {
    icon: "assets/images/owsem-service/service-icon-1.png",
    title: "Digital Marketing Strategy",
    description: "Maximize your reach with data-driven marketing campaigns, search engine optimization, and targeted advertising designed to convert traffic into loyal customers.",
    link: "/"
  },
  {
    icon: "assets/images/owsem-service/service-icon-2.png",
    title: "Business Transformation Strategy",
    description: "Align your business objectives with smart, scalable digital strategies that boost efficiency, profitability, and competitive edge.",
    link: "/"
  },
  {
    icon: "assets/images/owsem-service/service-icon-3.png",
    title: "Advanced Search Engine Optimization (SEO)",
    description: "Rank higher on Google with powerful SEO techniques that improve your website’s visibility, domain authority, and organic traffic.",
    link: "/"
  },
  {
    icon: "assets/images/owsem-service/service-icon-4.png",
    title: "Cross-Platform App Development",
    description: "Develop robust and engaging applications for iOS, Android, and the web using modern frameworks that ensure smooth performance across all devices.",
    link: "/"
  }
];

export const Aboutservices = [
  {
    icon: "assets/images/owsem-service/service-icon-1.png",
    score: "70",
    title: "Team Members",
  },
  {
    icon: "assets/images/owsem-service/service-icon-2.png",
    score: "4",
    title: "Winning Awards",
  },
  {
    icon: "assets/images/owsem-service/service-icon-3.png",
    score: "500",
    title: "Complete Project",
  },
  {
    icon: "assets/images/owsem-service/service-icon-4.png",
    score: "500",
    title: "Client Reviews",
  }
];


export const latestServices = [
  {
    title: "Web Development",
    description: "Create stunning, responsive websites with cutting-edge technologies",
    points: ["Custom Web Apps", "E-commerce Solutions", "CMS Development"],
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYJ77kdQWUax_AKgqLYUQhdvx-KiiUojVhcQ&s",
  },
  {
    title: "Mobile Development",
    description: "Build powerful mobile applications for iOS and Android platforms",
    points: ["Native Apps", "Cross-platform Solutions", "App Maintenance"],
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_TLDpA2oeO7SxHKqliteFtTVrcS6fuE3ffg&s",
  },
  {
    title: "UI/UX Design",
    description: "Create intuitive and engaging user experiences",
    points: ["User Research", "Wireframing", "Prototyping"],
    image: "https://www.aceinfoway.com/blog/wp-content/uploads/2020/05/uiux_2.jpg",
  },
  {
    title: "Cloud Solutions",
    description: "Scalable cloud infrastructure and deployment services",
    points: ["Cloud Migration", "DevOps", "Server Management"],
    image: "https://img.freepik.com/free-photo/saas-concept-collage_23-2149399285.jpg?semt=ais_hybrid&w=740",
  },
];

export const blogData = [
  {
    id: 1,
    image: 'https://media.licdn.com/dms/image/v2/D4D12AQGVpSxGo-Zumg/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1715496572770?e=2147483647&v=beta&t=QtpP0PHPNgh6XOOTs8lXTsj-IZ7wMD_XH3YDQ5OUwIw',
    title: 'How AI Is Revolutionizing Business Operations – And How We’re Leading the Change',
    // tags: ['Web design', 'Comments (05)', 'June 1, 2025'],
    paragraphs: [
      "Artificial Intelligence is no longer just a buzzword — it's a game-changer for businesses across the globe. At HNH Soft Tech Solutions, we have spent the past decade crafting intelligent systems that simplify complex operations, automate repetitive tasks, and boost decision-making power. Whether it’s predictive analytics, customer service chatbots, or intelligent workflow automation — our AI-driven solutions are transforming how our clients do business.",
      "Manual processes slow down productivity and increase the risk of human error. Our AI solutions automate everything from invoice processing and customer onboarding to inventory tracking. This not only reduces operational costs but also ensures accuracy, speed, and scalability for businesses looking to grow.",
      "Imagine being able to predict market trends, customer behavior, or equipment failures before they happen. Our team builds predictive models using historical data and machine learning to help businesses make proactive, data-backed decisions. This kind of foresight gives companies a significant competitive advantage in fast-moving industries.",
      "Today’s customers expect fast, personalized service. We integrate AI into customer service platforms — like chatbots and recommendation engines — that are available 24/7 and get smarter with each interaction. This improves response times, enhances customer satisfaction, and reduces the support team's workload.",
      "Every business is different. That’s why we don’t offer one-size-fits-all tools. We work closely with each client to understand their processes, pain points, and goals, and then design custom AI solutions that integrate seamlessly — whether they need help with fraud detection, HR analytics, or operational forecasting.",
      "AI isn’t just part of our service offering — it’s part of our identity. At HNH Soft Tech Solutions, we invest in R&D, collaborate with academic institutions, and continuously explore emerging technologies. Our mission is to help businesses not just adapt to the future — but lead it."
    ]
  },
  {
    id: 2,
    image: 'https://www.gislen.com/wp-content/uploads/2023/11/how-ai-is-reshaping-business-decision-making.webp',
    title: 'Predict, Don’t Guess: How AI Is Helping Businesses Make Smarter Decisions',
    // tags: ['UI/UX', 'Comments (03)', 'May 15, 2025'],
    paragraphs: [
      "Imagine knowing what your customers want — before they even say it. Through data-driven machine learning models and predictive analytics, we help our clients forecast sales, detect fraud, and identify trends early. At HNH Soft Tech Solutions, we turn raw data into actionable insights, giving your business a competitive edge in a rapidly changing world.",
      "Gone are the days of relying on gut feelings or spreadsheets. Our AI-powered forecasting tools analyze historical data, seasonal patterns, and consumer behavior to predict future sales more accurately. This allows businesses to optimize their inventory, align their marketing campaigns, and allocate resources more effectively — resulting in higher profitability and reduced waste.",
      "Fraud detection has become more complex — and more critical — than ever. Our AI solutions scan millions of transactions in real time, detecting suspicious patterns and flagging anomalies. Whether it's identifying fake user accounts, unauthorized payments, or phishing attempts, our systems can alert teams within seconds, minimizing risk and saving valuable time and money.",
      "The power of predictive analytics lies in its ability to see what others can’t. By analyzing large datasets from various sources — including social media, web traffic, and sales data — we help businesses identify emerging customer trends, product demand, and market shifts. This kind of insight empowers proactive decision-making and helps our clients stay ahead of the curve.",
      "AI isn't just about predictions — it's about making better decisions at every level of your organization. From strategic planning to customer support and marketing, data-driven insights improve efficiency and guide smarter actions. At HNH Soft Tech Solutions, we help you cut through the noise and focus on what really matters: results.",
      "Every business has different goals and different data. That’s why we build custom predictive models tailored to your specific needs. Whether you’re in retail, healthcare, logistics, or education — we work with you to identify your biggest challenges and use AI to create reliable, scalable solutions that evolve with your business.",
      "In today’s competitive landscape, guessing is not a strategy — predicting is. At HNH Soft Tech Solutions, we help you shift from reactive to proactive using cutting-edge AI tools that reveal opportunities, reduce risks, and drive innovation.",
      "Ready to make smarter decisions? Let’s talk."
    ]
  },
  {
    id: 3,
    image: 'https://miro.medium.com/v2/resize:fit:1400/1*wj7eFx14XfeVPE-Q-fcYZQ.jpeg',
    title: ' From Data to Decisions: Real-world AI Applications We’ve Built',
    // tags: ['Marketing', 'Comments (07)', 'April 28, 2025'],
    paragraphs: [
      
      "Every business has data, but not every business uses it effectively. At HNH Soft Tech Solutions, we’ve developed custom AI solutions — from healthcare analytics dashboards to retail inventory prediction engines. In this blog, we share some of the real-life projects where AI helped solve major business challenges.",
      "A leading healthcare provider approached us with one key challenge: turning scattered patient data into actionable insights. We built a real-time AI-powered dashboard that tracks patient vitals, treatment history, and diagnostic trends — enabling doctors to make quicker, data-backed decisions.",
      "The result? Reduced readmission rates, faster diagnosis, and improved patient care.",
      "One of our retail clients struggled with overstocking and stockouts. We implemented a machine learning model that predicted inventory needs based on sales history, seasonal trends, promotions, and even local events. The system helped reduce unnecessary inventory costs while ensuring popular items never ran out — leading to a 20% increase in sales efficiency.",
      "Fuel costs and delivery delays were major pain points for a logistics company we worked with. Using AI, we built a route optimization engine that considers traffic patterns, weather forecasts, delivery windows, and real-time GPS data. The company cut fuel consumption by 18% and reduced average delivery time by over 25%.",
      "Hiring the right talent is a challenge — especially at scale. We created a custom AI recruitment assistant that screens resumes, ranks applicants, and even predicts cultural fit based on company values. It not only shortened hiring cycles by 40%, but also boosted retention rates by identifying better-aligned candidates.",
      "We helped a fintech startup build an AI-based fraud detection system that flags suspicious transactions in real time. By analyzing spending behavior, geolocation, transaction frequency, and more, the system proactively blocks potentially fraudulent activity — keeping both users and the platform secure.",
    ]
  },
  {
    id: 4,
    image: 'https://landingi.com/wp-content/uploads/2024/10/Digital-Marketing-vs-Data-Analytics-optimized.webp',
    title: 'From Impressions to Conversions: How We Drive Results with Digital Marketing',
    // tags: ['Web design', 'Comments (05)', 'June 1, 2025'],
    paragraphs: [
      "Digital marketing is not about getting likes — it’s about getting leads. At HNH Soft Tech Solutions, we focus on campaigns that convert. Whether it’s Google Ads, SEO, or email marketing, our strategies are customized to bring in real results — more traffic, more leads, and more sales.",
      "SEO is more than just keywords. We conduct deep competitor analysis, optimize site structure, and create content that ranks organically on Google. Our approach helps businesses build sustainable visibility, attract the right audience, and reduce dependency on paid ads over time.",
      "One of our clients saw a 280% increase in organic traffic within 6 months after we overhauled their SEO strategy.",
      "Pay-per-click advertising can drain money if not handled smartly. We design and manage high-converting Google Ads campaigns using A/B testing, smart bidding strategies, and conversion tracking. The result? Lower cost per click and higher return on ad spend (ROAS).",
      "For an e-commerce client, we cut ad costs by 30% while increasing conversions by 45%",
      "We don’t just send emails — we build automated email funnels that nurture leads through every stage of the buying journey. From welcome series to cart recovery campaigns, our strategies are built to maximize engagement and drive action.",
      "One campaign we launched resulted in a 43% open rate and 19% conversion rate — far above industry averages.",
      "It’s not about followers — it’s about impact. Our team creates engaging content calendars, ad creatives, and influencer partnerships that align with your brand goals. Whether you’re looking to build community, increase brand awareness, or drive sales, we’ve got a strategy for it.",
      "Every campaign we launch is closely monitored and continuously optimized. We rely on analytics tools to track performance, identify what’s working (and what’s not), and adjust in real time to keep improving results. No guesswork — just measurable outcomes.",
    ]
  },
  {
    id: 5,
    image: 'https://www.smarterdigitalmarketing.co.uk/wp-content/uploads/2022/07/SEO-Using-Social-Media04.webp',
    title: 'SEO Isn’t Dead — It’s Smarter Than Ever (Here’s How We Do It)',
    // tags: ['Web design', 'Comments (05)', 'June 1, 2025'],
    paragraphs: [
      "If your website isn’t ranking on Google, it’s invisible to 90% of your potential customers. At HNH Soft Tech Solutions, we use advanced SEO techniques — from technical audits to high-quality content creation — to help our clients dominate search results and stay ahead of the competition.",
      "Behind every successful SEO strategy lies solid technical SEO. We start by conducting a thorough site audit to uncover hidden issues that could be preventing your site from ranking. From site speed optimization and mobile responsiveness to fixing broken links and improving crawlability, we ensure your site is fully optimized for search engines — giving you a competitive edge.",
      "Result: Websites with optimized technical SEO experience faster loading times, better user experience, and higher rankings.",
      "Content is king, but only when it's valuable, relevant, and optimized. We craft SEO-friendly content that answers your audience’s questions and addresses their needs. From blog posts and landing pages to product descriptions and how-to guides, we make sure your content is crafted with intent while incorporating highly searched keywords.",
      "Result: Clients see improved engagement and conversion rates as their content ranks higher on Google.",
      "On-page SEO goes beyond keywords. We meticulously optimize every aspect of your pages, including meta tags, headers, image alt text, and internal linking structure. By ensuring your site content is not only keyword-rich but also well-organized, we improve both Google rankings and user experience.",
      "Result: Better-optimized pages rank faster and are more likely to convert visitors into customers.",
      "SEO has evolved. Today, it’s not just about targeting keywords; it’s about understanding user intent. We analyze search queries to ensure your content answers your audience’s questions in the most valuable way possible. We then tailor the user experience to match their intent — whether they're looking for information, a product, or a service.",
      "Result: By focusing on user intent, we ensure our clients capture targeted traffic that converts.",
      "A crucial factor in Google’s ranking algorithm is link building. However, it’s not about quantity — it’s about quality. We focus on earning high-authority backlinks from reputable sites in your industry. This boosts your site’s domain authority and improves your chances of ranking at the top of search results.",
      "Result: Quality backlinks lead to higher rankings, driving organic traffic to your site.",
      "SEO isn’t a one-time effort — it’s an ongoing process. We continuously monitor performance with Google Analytics, Search Console, and keyword tracking tools. We constantly test, tweak, and refine our strategies to ensure your site remains at the top of search results, even as search algorithms evolve.",
      "Result: Our clients enjoy sustained growth and consistent traffic from search engines over time.",

    ]
  },];

export const recentBlogPosts = [
  {
    date:23,
    author:"Elon",
    image:
      "https://landingi.com/wp-content/uploads/2024/10/Digital-Marketing-vs-Data-Analytics-optimized.webp",
    category: "Digital Marketing",
    title: "From Impressions to Conversions: How We Drive Results with Digital Marketing",
     paragraphs: [
      "Digital marketing is not about getting likes — it’s about getting leads. At HNH Soft Tech Solutions, we focus on campaigns that convert. Whether it’s Google Ads, SEO, or email marketing, our strategies are customized to bring in real results — more traffic, more leads, and more sales.",
      "SEO is more than just keywords. We conduct deep competitor analysis, optimize site structure, and create content that ranks organically on Google. Our approach helps businesses build sustainable visibility, attract the right audience, and reduce dependency on paid ads over time.",
      "Pay-per-click advertising can drain money if not handled smartly. We design and manage high-converting Google Ads campaigns using A/B testing, smart bidding strategies, and conversion tracking. The result? Lower cost per click and higher return on ad spend (ROAS).",
      "We don’t just send emails — we build automated email funnels that nurture leads through every stage of the buying journey. From welcome series to cart recovery campaigns, our strategies are built to maximize engagement and drive action.",
      "It’s not about followers — it’s about impact. Our team creates engaging content calendars, ad creatives, and influencer partnerships that align with your brand goals. Whether you’re looking to build community, increase brand awareness, or drive sales, we’ve got a strategy for it.",
    ]
  },
  {
    date:12,
    author:"Jhon",
    image:
      "https://media.licdn.com/dms/image/v2/D4D12AQGVpSxGo-Zumg/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1715496572770?e=2147483647&v=beta&t=QtpP0PHPNgh6XOOTs8lXTsj-IZ7wMD_XH3YDQ5OUwIw",
    category: "Bussiness",
    title: "How AI Is Revolutionizing Business Operations",
     paragraphs: [
      "Artificial Intelligence is no longer just a buzzword — it's a game-changer for businesses across the globe. At HNH Soft Tech Solutions, we have spent the past decade crafting intelligent systems that simplify complex operations, automate repetitive tasks, and boost decision-making power. Whether it’s predictive analytics, customer service chatbots, or intelligent workflow automation — our AI-driven solutions are transforming how our clients do business.",
      "Manual processes slow down productivity and increase the risk of human error. Our AI solutions automate everything from invoice processing and customer onboarding to inventory tracking. This not only reduces operational costs but also ensures accuracy, speed, and scalability for businesses looking to grow.",
      "Imagine being able to predict market trends, customer behavior, or equipment failures before they happen. Our team builds predictive models using historical data and machine learning to help businesses make proactive, data-backed decisions. This kind of foresight gives companies a significant competitive advantage in fast-moving industries.",
      "Today's customers expect fast, personalized service. We integrate AI into customer service platforms — like chatbots and recommendation engines — that are available 24/7 and get smarter with each interaction. This improves response times, enhances customer satisfaction, and reduces the support team's workload.",
      "Every business is different. That's why we don't offer one-size-fits-all tools. We work closely with each client to understand their processes, pain points, and goals, and then design custom AI solutions that integrate seamlessly — whether they need help with fraud detection, HR analytics, or operational forecasting.",
      "AI isn't just part of our service offering — it's part of our identity. At HNH Soft Tech Solutions, we invest in R&D, collaborate with academic institutions, and continuously explore emerging technologies. Our mission is to help businesses not just adapt to the future — but lead it."
    ]
  },
  {
    date:17,
    author:"Mack",
    image: "https://www.smarterdigitalmarketing.co.uk/wp-content/uploads/2022/07/SEO-Using-Social-Media04.webp",
    category: "SEO",
    title: "SEO Isn't Dead — It's Smarter Than Ever",
     paragraphs: [
      "If your website isn’t ranking on Google, it’s invisible to 90% of your potential customers. At HNH Soft Tech Solutions, we use advanced SEO techniques — from technical audits to high-quality content creation — to help our clients dominate search results and stay ahead of the competition.",
      "Behind every successful SEO strategy lies solid technical SEO. We start by conducting a thorough site audit to uncover hidden issues that could be preventing your site from ranking. From site speed optimization and mobile responsiveness to fixing broken links and improving crawlability, we ensure your site is fully optimized for search engines — giving you a competitive edge.",
      "Content is king, but only when it's valuable, relevant, and optimized. We craft SEO-friendly content that answers your audience’s questions and addresses their needs. From blog posts and landing pages to product descriptions and how-to guides, we make sure your content is crafted with intent while incorporating highly searched keywords.",
      "On-page SEO goes beyond keywords. We meticulously optimize every aspect of your pages, including meta tags, headers, image alt text, and internal linking structure. By ensuring your site content is not only keyword-rich but also well-organized, we improve both Google rankings and user experience.",
      "SEO has evolved. Today, it’s not just about targeting keywords; it’s about understanding user intent. We analyze search queries to ensure your content answers your audience’s questions in the most valuable way possible. We then tailor the user experience to match their intent — whether they're looking for information, a product, or a service.",
      "A crucial factor in Google’s ranking algorithm is link building. However, it’s not about quantity — it’s about quality. We focus on earning high-authority backlinks from reputable sites in your industry. This boosts your site’s domain authority and improves your chances of ranking at the top of search results.",
      "SEO isn’t a one-time effort — it’s an ongoing process. We continuously monitor performance with Google Analytics, Search Console, and keyword tracking tools. We constantly test, tweak, and refine our strategies to ensure your site remains at the top of search results, even as search algorithms evolves.",
    ]
  },
];
export const portfolioAll = [
  {
    id: 1,
    title: 'A full-featured e-commerce platform with advanced filtering and payment integration.',
    subtitle: 'E-commerce Platform',
    image: 'assets/images/portfolio/portfolio-one.jpg',
    showIcon: true,
  },
  {
    id: 2,
    title: 'Cross-platform mobile app for tracking workouts and nutrition.',
    subtitle: 'Fitness Tracking App',
    image: 'assets/images/portfolio/portfolio-two.jpg',
    showIcon: true,
  },
  {
    id: 3,
    title: 'Modern corporate website with dynamic content management.',
    subtitle: 'Corporate Website',
    image: 'assets/images/portfolio/portfolio-three.jpg',
    showIcon: true,
  },
  {
    id: 4,
    title: 'Comprehensive cloud resource management dashboard.',
    subtitle: 'Cloud Management Dashboard',
    image: 'assets/images/portfolio/portfolio-four.jpg',
    showIcon: true,
  },
];
export const portfolioMobile = [
  {
    id: 1,
    title: 'A full-featured e-commerce platform with advanced filtering and payment integration.',
    subtitle: 'E-commerce Platform',
    image: 'assets/images/portfolio/portfolio-one.jpg',
    showIcon: true,
  },
  {
    id: 4,
    title: 'Comprehensive cloud resource management dashboard.',
    subtitle: 'Cloud Management Dashboard',
    image: 'assets/images/portfolio/portfolio-four.jpg',
    showIcon: true,
  },
];
export const portfolioWeb = [
  {
    id: 2,
    title: 'Cross-platform mobile app for tracking workouts and nutrition.',
    subtitle: 'Fitness Tracking App',
    image: 'assets/images/portfolio/portfolio-two.jpg',
    showIcon: true,
  },
  {
    id: 3,
    title: 'Modern corporate website with dynamic content management.',
    subtitle: 'Corporate Website',
    image: 'assets/images/portfolio/portfolio-three.jpg',
    showIcon: true,
  },
];
export const portfolioDesign = [
  {
    id: 4,
    title: 'Comprehensive cloud resource management dashboard.',
    subtitle: 'Cloud Management Dashboard',
    image: 'assets/images/portfolio/portfolio-four.jpg',
    showIcon: true,
  },
];
export const portfolioCloud = [
  {
    id: 1,
    title: 'A full-featured e-commerce platform with advanced filtering and payment integration.',
    subtitle: 'E-commerce Platform',
    image: 'assets/images/portfolio/portfolio-one.jpg',
    showIcon: true,
  },
];
export const testimonials = [
  {
    text: `"We've been working with HNH Soft Tech Solutions for over 3 years now, and their commitment to delivering high-quality software solutions is unmatched. Their team is professional, responsive, and always goes the extra mile."`,
    name: "Emma Johnson",
    role: "Operations Manager",
    image: "assets/images/testimonial/testimonial-img-1.jpeg",
    rating:3
  },
  {
    text: `"HNH Soft Tech Solutions helped us transform our outdated system into a sleek, user-friendly platform. Their experience and deep technical knowledge made a huge difference in our project's success."`,
    name: "Michael Roberts",
    role: "CEO",
    image: "assets/images/testimonial/testimonial-img-2.jpeg",
    rating:4
  },
  {
    text: `
"From the first meeting to the final delivery, HNH Soft Tech Solutions proved to be a reliable partner. They understood our needs perfectly and provided innovative solutions that exceeded our expectations."`,
    name: "Olivia Harris",
    role: "Marketing Head",
    image: "assets/images/testimonial/testimonial-img-1.jpeg",
    rating:3
  },

]